import React, { useEffect, useState } from "react"
import {
  FormErrorMessage,
  FormControl,
  FormLabel,
  InputLeftElement,
  InputGroup,
  Input,
} from "@chakra-ui/react"
import { Icon } from "../"

export default function FormSubject({
  updateSubject,
  register,
  subject,
  success,
  error,
}) {
  const [isError, setIsError] = useState(false)

  const handleChange = evt => {
    updateSubject(evt.target.value)
  }

  useEffect(() => {
    if (error) {
      subject.length > 0 ? setIsError(false) : setIsError(true)
    }
  }, [error, subject.length])

  return (
    <FormControl isInvalid={isError}>
      <FormLabel htmlFor="subject">Subject *</FormLabel>
      <InputGroup>
        <InputLeftElement
          pointerEvents="none"
          children={<Icon name="paperScroll" color="primary.200" />}
        />
        <Input
          {...(success && { pointerEvents: "none" })}
          {...register("subject", {
            required: {
              value: true,
              message: "Please indicate a subject matter",
            },
          })}
          onChange={evt => handleChange(evt)}
          defaultValue={subject}
        />
      </InputGroup>
      <FormErrorMessage>{isError && error.message}</FormErrorMessage>
    </FormControl>
  )
}
